var states = {
  home: { url: "/", path: "/" },
  // Dashboard subpages
  dashboard: { url: "/dashboard", path: "dashboard" },
  dashboardOverview: { url: "/dashboard/overview", path: "overview" },
  // New loans subpages
  newLoans: { url: "/newLoans", path: "newLoans" },
  newLoansApplications: { url: "/newLoans/applications", path: "applications" },
  newCreditApplications: {
    url: "/newLoans/creditApplications",
    path: "creditApplications",
  },
  newLoansTasks: { url: "/newLoans/tasks", path: "tasks" },
  preApplications: {
    url: "/newLoans/pre-applications",
    path: "pre-applications",
  },
  underReviewApplications: {
    url: "/newLoans/applications-under-review",
    path: "applications-under-review",
  },
  underReviewCreditApplications: {
    url: "/newLoans/credit-applications-under-review",
    path: "credit-applications-under-review",
  },
  newLoansPayout: { url: "/newLoans/payouts", path: "payouts" },
  newLoansLoans: { url: "/newLoans/loans", path: "loans" },
  loanstepOrders: { url: "/newLoans/loanstepOrders", path: "loanstepOrders" },
  specialAccounts: {
    url: "/newLoans/specialAccounts",
    path: "specialAccounts",
  },
  ssnBlocking: { url: "/newLoans/ssnBlocking", path: "ssnBlocking" },
  restRepaymentLoans: { url: "/newLoans/RestRepayment", path: "RestRepayment" },
  kreditzReports: { url: "/newLoans/kreditz", path: "kreditz(/:id)" },

  // statistics
  statistics: { url: "/statistics", path: "statistics" },
  statisticsTransactions: {
    url: "/statistics/transaction",
    path: "transaction",
  },
  statisticsCurrent: {
    url: "/statistics/state-of-system",
    path: "state-of-system",
  },
  // Aml
  aml: { url: "/aml", path: "aml" },
  amlWarnings: { url: "/aml/warnings", path: "warnings" },
  amlRules: { url: "/aml/rules", path: "rules" },
  // Other pages
  twoStepAuth: { url: "/twoStepAuth", path: "twoStepAuth" },
  credits: { url: "/credits", path: "credits" },
  invoices: { url: "/invoices", path: "invoices" },
  creditSettlement: { url: "/creditSettlement", path: "creditSettlement" },
  user: { url: "/user", path: "user" },
  userOverview: { url: "/user/overview", path: "overview(/:type/:id)" },
  // Borrower routes
  userApplications: {
    url: "/user/applications",
    path: "applications(/:type/:id)",
  },
  userCreditApplications: {
    url: "/user/creditApplications",
    path: "creditApplications(/:type/:id)",
  },
  userInvoices: { url: "/user/invoices", path: "invoices(/:type/:id)" },
  userLoans: { url: "/user/loans", path: "loans(/:type/:id)" },
  // Lender routes
  userFinancings: { url: "/user/financings", path: "financings(/:type/:id)" },
  userTransactions: {
    url: "/user/transactions",
    path: "transactions(/:type/:id)",
  },
  userOrders: { url: "/user/orders", path: "orders(/:type/:id)" },
  userAMLProfile: { url: "/user/amlProfile", path: "amlProfile(/:type/:id)" },
  userClaims: { url: "/user/claims", path: "claims(/:type/:id)" },
  // Main routes
  financing: { url: "/financing", path: "financing" },
  transactions: { url: "/transactions", path: "transactions" },
  applications: { url: "/applications", path: "applications" },
  menuOrders: { url: "/orders", path: "orders" },
  orders: { url: "/savelendStuff/orders", path: "orders" },
  marketplace: { url: "/marketplace", path: "marketplace" },
  autogiro: { url: "/newLoans/autogiro", path: "autogiro" },
  // Acounting routes
  accounting: { url: "/accounting", path: "accounting" },
  registerPayments: {
    url: "/accounting/register-payments",
    path: "register-payments",
  },
  registerMarketplacePayments: {
    url: "/accounting/register-marketplace-payments",
    path: "register-marketplace-payments",
  },
  registerSolvenPayments: {
    url: "/accounting/register-solven-payments",
    path: "register-solven-payments",
  },
  matchPayments: { url: "/accounting/match-payments", path: "match-payments" },
  matchPaymentsDeposits: {
    url: "/accounting/match-payments/deposits",
    path: "deposits",
  },
  matchPaymentsInvoices: {
    url: "/accounting/match-payments/invoices",
    path: "invoices",
  },
  confirmPayments: {
    url: "/accounting/confirm-payments",
    path: "confirm-payments",
  },
  confirmInvestorDeposits: {
    url: "/accounting/confirm-payments/investor-deposits",
    path: "investor-deposits",
  },
  confirmPaymentsDeposits: {
    url: "/accounting/confirm-payments/deposits",
    path: "deposits",
  },
  confirmPaymentsInvoices: {
    url: "/accounting/confirm-payments/invoices",
    path: "invoices",
  },
  exportToFortnox: {
    url: "/accounting/export-to-fortnox",
    path: "export-to-fortnox",
  },
  // System

  menuSettings: { url: "/settings", path: "settings" },
  browser: { url: "/settings/browser", path: "browser" },
  autoinvest: { url: "/settings/autoinvest", path: "autoinvest" },
  terms: { url: "/settings/terms", path: "terms" },
  templates: { url: "/settings/templates", path: "templates" },
  settings: { url: "/settings/settings", path: "settings" },

  // Tremination Process
  terminatedSale: { url: "/terminatedSale", path: "terminatedSale" },
  terminatedCollection: {
    url: "/terminatedCollection",
    path: "terminatedCollection",
  },
  soldMenu: { url: "/soldMenu", path: "soldMenu" },
  sold: { url: "/soldMenu/sold", path: "sold" },
  dca: { url: "/soldMenu/dca", path: "dca" },

  // Savelend Account Money Withdrawal
  savelend: { url: "savelend", path: "savelend" },
  savelendStuff: { url: "/savelendStuff", path: "savelendStuff" },
  savelendMoneyTransactions: {
    url: "/savelendStuff/transactions",
    path: "transactions",
  },
  referAFriend: { url: "/savelendStuff/referAFriend", path: "referAFriend" },
  affiliates: { url: "/savelendStuff/affiliates", path: "affiliates" },

  // Reports
  reports: { url: "/reports", path: "reports" },
  ucReports: { url: "/reports/ucReports", path: "ucReports" },
  crmReports: { url: "/reports/crmReports", path: "crmReports" },
  taxReports: { url: "/reports/taxReports", path: "taxReports" },
  monthlyReports: { url: "/reports/monthlyReports", path: "monthlyReports" },
  borrowerSurplus: { url: "/reports/borrowerSurplus", path: "borrowerSurplus" },

  // MPL
  mpl: { url: "/mpl", path: "mpl" },
  mplCreate: { url: "/mpl/create", path: "create" },
  mplFinancing: { url: "/mpl/financing", path: "financing" },
  mplPayout: { url: "/mpl/payout", path: "payout" },
};

export default states;
